import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {InviaTypeIcon} from '@travel-frontend/ui-components';

import {testId} from '@/utils/testId';

const Badge = styled.div(
  ({theme}) => css`
    padding: 0px 8px 0px 4px;
    color: ${theme.colors.contentInversePrimary};
    background: ${theme.colors.contentBrand};
    border-radius: 4px;
    display: inline-flex;
    gap: 4px;
    align-items: center;

    ${InviaTypeIcon} {
      width: 18px;
      height: 18px;
    }
  `
);

const Label = styled.div(
  ({theme}) => css`
    ${theme.typography.paragraphXSmallBold};
    white-space: nowrap;
    text-transform: uppercase;
    align-self: center;
  `
);

type Props = React.ComponentPropsWithoutRef<typeof Badge> & {
  type: string;
  name: string;
};

export const HotelTypeBadge = styled(({type, name, ...restProps}: Props) => {
  return (
    <Badge {...restProps} data-testid={testId(`hotelType-badge`)}>
      <InviaTypeIcon inviaType={type} />
      <Label>{name}</Label>
    </Badge>
  );
})``;
